import clsx from 'clsx';
import { ReactNode } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';

import { CustomIcon } from '../Icon';

import '@hotmart/cosmos/dist/dropdown';
import '@hotmart/cosmos/dist/button/button.css';
import { DropdownItem } from './DropdownItem';
import { Label } from './DropdownItem.styles';

export type ItemProps = {
  name: string;
  handleClick: () => void;
  testId: string;
};

export type DropdownProps = {
  label?: string;
  items?: ItemProps[];
  testId: string;
  className?: string;
  buttonClassName?: string;
  disabled?: boolean;
  loading?: boolean;
  icon?: IconDefinition;
  children?: ReactNode;
};

const Dropdown = ({
  label,
  items,
  className,
  buttonClassName,
  testId,
  disabled,
  loading,
  icon,
  children
}: DropdownProps) => {
  return (
    <div className={clsx('_d-flex _align-items-center', className)}>
      <hot-dropdown class="hot-dropdocked">
        <button
          slot="button"
          className={clsx(
            'hot-button hot-dropdown__toggle _text-gray-700 _d-flex _align-items-center',
            {
              '_rounded-pill': !icon,
              '_border-0 _p-2': Boolean(icon),
              'hot-button--loading': Boolean(loading)
            },
            buttonClassName
          )}
          data-test={testId}
          disabled={disabled}
        >
          {label ? (
            <Label visible={!loading}>{label}</Label>
          ) : (
            <span className="_sr-only">{testId}</span>
          )}
          <CustomIcon
            icon={icon ?? faChevronDown}
            className={clsx({
              '_ml-2': !icon
            })}
          />
        </button>
        {items?.map((item) => (
          <hot-dropdown-menu-item
            key={item.name}
            slot="menu"
            data-test={item.testId}
            onClick={() => item.handleClick()}
          >
            {item.name}
          </hot-dropdown-menu-item>
        ))}
        {!items ? children : null}
      </hot-dropdown>
    </div>
  );
};

Dropdown.Item = DropdownItem;

export default Dropdown;
